import React, { useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CustomToast = ({
  position = "top-right",
  autoClose = 5000,
  message,
  type = "default",
}) => {
  const commonStyles = {
    borderRadius: "8px",
    padding: "15px",
    fontSize: "14px",
    fontWeight: "bold",
  };

  useEffect(() => {
    let toastStyle = { ...commonStyles };
    switch (type) {
      case "info":
        toastStyle = {
          ...toastStyle,
          backgroundColor: "#007bff",
          color: "white",
        };
        toast.info(message, { position, autoClose, style: toastStyle });
        break;
      case "success":
        toastStyle = {
          ...toastStyle,
          backgroundColor: "#28a745",
          color: "white",
        };
        toast.success(message, { position, autoClose, style: toastStyle });
        break;
      case "warning":
        toastStyle = {
          ...toastStyle,
          backgroundColor: "#ffc107",
          color: "black",
        };
        toast.warn(message, { position, autoClose, style: toastStyle });
        break;
      case "error":
        toastStyle = {
          ...toastStyle,
          backgroundColor: "#dc3545",
          color: "white",
        };
        toast.error(message, { position, autoClose, style: toastStyle });
        break;
      default:
        toast(message, { position, autoClose, style: toastStyle });
    }
  }, [message, position, autoClose, type]);

  return <ToastContainer />;
};

export default CustomToast;
